import { cn } from "@/lib/utils";
import apiRoutes from "@/src/apiRoutes";
import { Button } from "@/src/components/Button/Button";
import { textVariants } from "@/src/components/Text/Text";
import api from "@/src/utils";
import mining from "@assets/btcMining.svg";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

const Rewards = () => {
  const { t } = useTranslation();
  const trans = (key: string) => t(`app.referAndEarn.rewards.${key}`);
  const getReferPoints = async () => {
    const res = await api.post(apiRoutes.rewards, {
      type: "points",
    });
    return res.data;
  };

  const { data } = useQuery({
    queryKey: ["referral_points"],
    queryFn: getReferPoints,
  });

  const withdraw = async () => {
    const res = await api.post(apiRoutes.rewards, {
      type: "withdraw",
    });
    return res.data;
  };

  const { mutate, isLoading } = useMutation({
    mutationFn: withdraw,
    onSuccess: (data) => {
      if (data?.success) {
        toast.success(data?.info);
      } else {
        toast.warning(data?.info);
      }
    },
  });

  return (
    <>
      <div className="flex flex-col  mx-auto md:p-16 p-8 bg-white dark:bg-[#212741] rounded-md">
        <div className="grid md:grid-cols-2 ">
          <div className="flex flex-col justify-center gap-4 md:w-4/5 ">
            <h2
              className={cn(
                textVariants({ size: "xxxxl", font: "semibold" }),
                "max-md:text-base"
              )}
            >
              {trans("header")}
            </h2>
            <span className={textVariants({ size: "sm", variant: "desc" })}>
              {trans("description")}
            </span>
            <div className="flex">
              <div className="grid rounded-lg border border-blue-700 dark:border-blue-100/20 bg-[#E7EDF7] dark:bg-[#212741] py-2 pl-3 w-full">
                <span
                  className={cn(
                    textVariants({ size: "xl", font: "medium" }),
                    "max-sm:text-sm"
                  )}
                >
                  {trans("points.label")}
                </span>
                <span
                  className={cn(
                    textVariants({ size: "xl", font: "medium" }),
                    "max-sm:text-sm"
                  )}
                >
                  {data?.info ?? 0}
                </span>
              </div>
            </div>
            <div className="flex space-x-3">
              <Button
                onClick={() => mutate()}
                loading={isLoading}
                className="w-full py-4 text-md flex-1"
              >
                {trans("points.withdrawButton")}
              </Button>
              {/* <Button
                // onClick={() => setOpenScan(true)}
                className="flex-1"
                // className="bg-blue-600 hover:bg-blue-700 text-white py-6"
              >
                <QrCode className="mr-2 h-5 w-5" />
                Scan
              </Button> */}
            </div>
          </div>
          <div className="flex justify-center items-center  ">
            <img src={mining} alt="mine" className="h-full" />
          </div>
        </div>
      </div>

      {/* <div className="bg-white dark:bg-[#212741] my-10 py-16 px-4 md:px-12">
        <h3
          className={cn(
            textVariants({ size: "xxl", font: "semibold" }),
            "mb-5 max-md:text-base"
          )}
        >
          New Challenge
        </h3>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          <div className="flex flex-col gap-4 border-2 border-[#ecf0fa] dark:border-blue-100/20 py-6 px-4 rounded-2xl">
            <div className="grid relative grid-cols-9 mb-4">
              <span className="bg-[#defaf6] col-span-1 rounded-r-md py-12"></span>
              <span className="bg-gradient-to-r from-[#defaf6] to-[#c0d2f3] flex flex-col gap-3 justify-center col-span-8 rounded-l-md">
                <p className="font-bold text-xl text-center">200 Point</p>
                <p className="text-center">200 Point</p>
              </span>
            </div>
            <p
              className={cn(
                textVariants({ size: "xxl", font: "bold" }),
                "text-center"
              )}
            >
              Sell your BTC 2000USD
            </p>
            <p className="text-muted-foreground text-lg">
              And enter into a mystery bix and get up to 10% Discount on sales
            </p>
            <Button className="block w-full bg-[#e7edf7] text-muted-foreground py-3">
              Sell Now
            </Button>
            <div className="grid grid-cols-3">
              <div className="flex gap-1 justify-center items-center">
                <span className="text-blue-700 font-semibold">05</span>
                <span
                  className={cn(
                    textVariants({ size: "md", font: "semibold" }),
                    "text-muted-foreground"
                  )}
                >
                  Days
                </span>
              </div>
              <div className="flex gap-1 justify-center items-center">
                <span
                  className={cn(
                    textVariants({ size: "md", font: "semibold" }),
                    "text-muted-foreground"
                  )}
                >
                  06
                </span>
                <span className="text-muted-foreground">Hours</span>
              </div>
              <div className="flex gap-1 justify-center items-center">
                <span
                  className={cn(
                    textVariants({ size: "md", font: "semibold" }),
                    "text-muted-foreground"
                  )}
                >
                  34
                </span>
                <span className="text-muted-foreground">Mins</span>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-4 border-2 border-[#ecf0fa] dark:border-blue-100/20 py-6 px-4 rounded-2xl">
            <div className="grid relative grid-cols-9 mb-4">
              <span className="bg-[#defaf6] col-span-1 rounded-r-md py-12"></span>
              <span className="bg-gradient-to-r from-[#defaf6] to-[#c0d2f3] flex flex-col gap-3 justify-center col-span-8 rounded-l-md">
                <p className="font-bold text-xl text-center">200 Point</p>
                <p className="text-center">200 Point</p>
              </span>
            </div>
            <p
              className={cn(
                textVariants({ size: "xxl", font: "bold" }),
                "text-center"
              )}
            >
              Sell your BTC 2000USD
            </p>
            <p className="text-muted-foreground text-lg">
              And enter into a mystery bix and get up to 10% Discount on sales
            </p>
            <Button className="block w-full bg-[#e7edf7] text-muted-foreground py-3">
              Sell Now
            </Button>
            <div className="grid grid-cols-3">
              <div className="flex gap-1 justify-center items-center">
                <span className="text-blue-700 font-semibold">05</span>
                <span
                  className={cn(
                    textVariants({ size: "md", font: "semibold" }),
                    "text-muted-foreground"
                  )}
                >
                  Days
                </span>
              </div>
              <div className="flex gap-1 justify-center items-center">
                <span
                  className={cn(
                    textVariants({ size: "md", font: "semibold" }),
                    "text-muted-foreground"
                  )}
                >
                  06
                </span>
                <span className="text-muted-foreground">Hours</span>
              </div>
              <div className="flex gap-1 justify-center items-center">
                <span
                  className={cn(
                    textVariants({ size: "md", font: "semibold" }),
                    "text-muted-foreground"
                  )}
                >
                  34
                </span>
                <span className="text-muted-foreground">Mins</span>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-4 border-2 border-[#ecf0fa] dark:border-blue-100/20 py-6 px-4 rounded-2xl">
            <div className="grid relative grid-cols-9 mb-4">
              <span className="bg-[#defaf6] col-span-1 rounded-r-md py-12"></span>
              <span className="bg-gradient-to-r from-[#defaf6] to-[#c0d2f3] flex flex-col gap-3 justify-center col-span-8 rounded-l-md">
                <p className="font-bold text-xl text-center">200 Point</p>
                <p className="text-center">200 Point</p>
              </span>
            </div>
            <p
              className={cn(
                textVariants({ size: "xxl", font: "bold" }),
                "text-center"
              )}
            >
              Sell your BTC 2000USD
            </p>
            <p className="text-muted-foreground text-lg">
              And enter into a mystery bix and get up to 10% Discount on sales
            </p>
            <Button className="block w-full bg-[#e7edf7] text-muted-foreground py-3">
              Sell Now
            </Button>
            <div className="grid grid-cols-3">
              <div className="flex gap-1 justify-center items-center">
                <span className="text-blue-700 font-semibold">05</span>
                <span
                  className={cn(
                    textVariants({ size: "md", font: "semibold" }),
                    "text-muted-foreground"
                  )}
                >
                  Days
                </span>
              </div>
              <div className="flex gap-1 justify-center items-center">
                <span
                  className={cn(
                    textVariants({ size: "md", font: "semibold" }),
                    "text-muted-foreground"
                  )}
                >
                  06
                </span>
                <span className="text-muted-foreground">Hours</span>
              </div>
              <div className="flex gap-1 justify-center items-center">
                <span
                  className={cn(
                    textVariants({ size: "md", font: "semibold" }),
                    "text-muted-foreground"
                  )}
                >
                  34
                </span>
                <span className="text-muted-foreground">Mins</span>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default Rewards;
